import React from 'react';
import { UserIcon, UsersIcon, PresentationIcon, MountainIcon, LaptopIcon, ClockIcon } from 'lucide-react';
const rooms = [{
  title: 'Private 1:1 sessions',
  body: 'Session formulas for 60, 90 and 120 minutes, plus 15 themed sessions in Volume 2.',
  Icon: UserIcon
}, {
  title: 'Group circles',
  body: 'Volume 4: the Circle Container, 10 themed circles and a 12-month circle calendar.',
  Icon: UsersIcon
}, {
  title: 'Workshops & wellness centers',
  body: 'Volume 5: run sheets from a 45-minute taster to a full-day immersion, plus a workplace session.',
  Icon: PresentationIcon
}, {
  title: 'Retreats',
  body: 'Volume 6: weekend and 5-day retreat arcs, from the morning breath to the closing circle.',
  Icon: MountainIcon
}, {
  title: 'Online sessions',
  body: 'Online 1:1s, online circles and hybrid rooms, with the Remote Safety Protocol.',
  Icon: LaptopIcon
}, {
  title: 'Busy weeks',
  body: 'The Printable Breath Card Deck and each volume’s quick-start page: your next circle with 30 minutes of prep.',
  Icon: ClockIcon
}];
export function UseCases() {
  return <section aria-labelledby="rooms-heading" className="w-full bg-sand" data-id="element-279" data-mp="2wqxtuab8d6o8">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:py-20" data-id="element-280" data-mp="2ivc606gqgsxe">
        <div className="text-center" data-id="element-281" data-mp="2mucnnlnh5pit">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-terra-deep" data-id="element-282" data-mp="2mve8uiy7fse9">
            Who it’s for
          </p>
          <h2 id="rooms-heading" className="chalk-underline mt-3 font-display text-[28px] text-sage sm:text-5xl" data-id="element-283" data-mp="3fjs5au9nagnp">
            Built for every room you breathe in
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-284" data-mp="35tgrmg05st3m">
            For trained conscious connected breathwork facilitators working
            with adults — in private practice, wellness centers, retreats and
            online.
          </p>
        </div>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-285" data-mp="26q9cmljvf93">
          {rooms.map(({
          title,
          body,
          Icon
        }) => <li key={title} className="flex items-start gap-3 rounded-2xl border border-sand-dark bg-cream p-5" data-id="element-286" data-mp="7yr0gpexjumg">
              <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-sage text-cream" data-id="element-287" data-mp="2ycst8h8qmoy">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-288" data-mp="3u8uwqw3a5pxf" />
              </span>
              <span data-id="element-289" data-mp="3p9idelbmb0zl">
                <span className="block font-display text-lg leading-snug text-sage" data-id="element-290" data-mp="3kgp89wc8lqmz">
                  {title}
                </span>
                <span className="mt-1 block text-sm text-ink-soft" data-id="element-291" data-mp="3geamp4h6ocs0">{body}</span>
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}